import {useLocation} from "react-router-dom";
import {getLangFromUrl} from "Translator";

function usePathnameWithNoLangCode() {
  const { pathname } = useLocation();
  const langCode = getLangFromUrl();

  if (langCode !== 'en') {
    return pathname.replace(`/${langCode}`, '');
  }
  return pathname;
}

export default usePathnameWithNoLangCode;
